import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import hasPermissionDirective from './directives/has-permission'
import './plugins'
import './assets/plutao-main.css'
import VueCookies from 'vue-cookies'
import versionable from './plugins/versionable/versionable'
import message from './plugins/message'

Vue.config.productionTip = false
Vue.use(VueCookies)

Vue.directive('has-permission', hasPermissionDirective)
Vue.use(versionable)
Vue.use(message)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
